<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <b-card v-if="tabelaCreditosPendentes.length > 0">
      <b-card-title> Créditos Pendentes </b-card-title>
      <div class="table-responsive font-size-12 m-auto">
        <b-table
          responsive="sm"
          :fields="camposCreditos"
          :items="tabelaCreditosPendentes"
          tbody-tr-class="div-clickable"
          @row-clicked="proximaPagina"
          hover
        >
          <template v-slot:cell(ds_st_liberacao)="data">
            <div class="d-flex">
              <div
                class="retangulo mr-2"
                :class="{
                  'bg-danger': data.value === 'Pendente',
                  'bg-success': data.value === 'Liberado',
                  'bg-warning': data.value === 'Autorizado',
                }"
              ></div>
              <span>{{ data.item.status }} </span>
            </div>
          </template>
        </b-table>
      </div>
    </b-card>
    <b-card v-if="tabelaCreditos.length > 0">
      <b-card-title> Créditos Liberados </b-card-title>
      <div class="table-responsive font-size-12 m-auto">
        <b-table
          responsive="sm"
          :fields="camposCreditos"
          :items="tabelaCreditos"
          tbody-tr-class="div-clickable"
          @row-clicked="proximaPagina"
          hover
        >
          <template v-slot:cell(ds_st_liberacao)="data">
            <div class="d-flex">
              <div
                class="retangulo mr-2"
                :class="{
                  'bg-danger': data.value === 'Pendente',
                  'bg-success': data.value === 'Liberado',
                  'bg-warning': data.value === 'Autorizado',
                }"
              ></div>
              <span>{{ data.item.status }}</span>
            </div>
          </template>
        </b-table>
      </div>
    </b-card>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      title: "Liberação de Créditos",
      items: [
        {
          text: "Liberação de Créditos",
        },
      ],
      camposCreditos: [
        {
          key: "ds_st_liberacao",
          label: "Status",
        },
        {
          key: "nr_ano",
          label: "Ano",
        },
        {
          key: "sq_libera_credito",
          label: "N°Lote",
        },
        {
          key: "vl_credito",
          label: "Créditos",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "vl_baixa",
          label: "Compensações",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "vl_saldo",
          label: "Saldo",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "vl_liberado",
          label: "Liberado",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "dt_autorizacao",
          label: "Autorização",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "dt_vencimento",
          label: "Vencimento",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "ds_tp_opcao",
          label: "Destino",
        },
        {
          key: "ds_st_liberacao_obs",
          label: "Observação",
        },
      ],
      tabelaCreditos: [],
      tabelaCreditosPendentes: [],
    };
  },
  created() {
    this.buscarLiberacaoCredito();
    if (this.$store.state.notificacao) {
      this.$tools.alerta(
        this.$store.state.notificacao.notificacao,
        this.$store.state.notificacao.icone
      );
      this.$store.commit("ENVIAR_NOTIFICACAO", null); //Esvazia notificação
    }
    this.$tools.fecharMenu();
  },
  methods: {
    proximaPagina(item) {
      if (item.ds_st_liberacao == "Pendente") {
        this.$router.push(
          "liberacaoCredito/creditoPendente/" + item.sq_libera_credito
        );
      } else {
        this.$router.push(
          "liberacaoCredito/creditoLiberado/" + item.sq_libera_credito
        );
      }
    },
    buscarLiberacaoCredito() {
      this.$http
        .get("api/contaCorrente/liberacaoCredito/buscarLiberacao/0")
        .then((response) => {
          if (response.data) {
            response.data.forEach((el) => {
              if (
                el.ds_st_liberacao == "Pendente" ||
                el.ds_st_liberacao == "Autorizado"
              ) {
                this.tabelaCreditosPendentes.push(el);
              } else {
                this.tabelaCreditos.push(el);
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>